import React, { PropTypes } from 'react';
import NovoPontoRetanguloBase from './NovoPontoRetanguloBase';
import Rect from './Rect';

export default class NovoRetangulo extends NovoPontoRetanguloBase {
	
	componentDidMount() {
		this.setState({
			textoBotao: 'Novo retângulo',
			textoLabel: 'Adicionar novo retângulo'
		});
	}

	novo() {
		this.props.createRect({ isCreating: true });
		this.setState({is_lightbox_open: true}); 
	}

	cancelar() {
		this.props.removeRect(this.props.rects.length -1 );
		this.setState({is_lightbox_open: false}); 
	}

	finalizar() {
		this.props.setIsCreatingRect(this.props.rects.length-1, false);
	}

	conteudoLightbox() {
		return (
			<div>
				<Rect 					
                    rect={this.props.rects.at(-1)}
                    index={this.props.rects.length-1}			
                    removeRect={this.props.removeRect} 
                    setLatNw={this.props.setLatNw}
                    setLngNw={this.props.setLngNw}
                    setLatSe={this.props.setLatSe}
                    setLngSe={this.props.setLngSe}
                />
			</div>
		);
	}
}

NovoRetangulo.propTypes = {
	rects: PropTypes.array.isRequired,
	removeRect: PropTypes.func.isRequired,
	createRect: PropTypes.func.isRequired,
	setIsCreatingRect: PropTypes.func.isRequired,
	setLatNw: PropTypes.func.isRequired,
	setLngNw: PropTypes.func.isRequired,
	setLatSe: PropTypes.func.isRequired,
	setLngSe: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Documents/NovoRetangulo.js